import {Component, EventEmitter, Input, Output} from '@angular/core';
import { FaqFolderDetailDto } from '../../../domain/faq/faqNodeDetailDto';
import { FaqNodeDto } from '../../../domain/faq/faqNodeDto';

@Component({
    selector: 'faq-folder',
    templateUrl: './faqFolder.component.html',
    styleUrls: ['./faqFolder.component.scss'],
})
export class FaqFolderComponent {
    @Input() faqFolder: FaqFolderDetailDto;
    @Output() faqNodeSelected: EventEmitter<FaqNodeDto> = new EventEmitter<FaqNodeDto>();

    constructor() {
    }

    selectFaqNode(faqNode: FaqNodeDto): void {
        this.faqNodeSelected.emit(faqNode);
    }
}
